import type { ICampaignMessageToastKey, MessageToast } from '../types';

export const CAMPAIGN_MSG: Record<ICampaignMessageToastKey, MessageToast> = {
  CREATE: {
    SUCCESS: 'Experiment created',
    FAILED: 'Experiment create failed',
  },
  WINNER: {
    SUCCESS: 'Choose winner successfully',
    FAILED: 'Choose winner failed',
  },
  UPDATE: {
    SUCCESS: 'Changes saved',
    FAILED: 'Experiment update failed',
  },
  UPDATE_BULK: {
    SUCCESS: 'Experiments updated',
    FAILED: 'Experiments update failed',
  },
  DELETE: {
    SUCCESS: 'Experiment deleted',
    FAILED: 'Experiment delete failed',
  },
  AUTO_SAVE: {
    SUCCESS: 'Autosave success',
    FAILED: 'Autosave failed',
  },
  RUNNING: {
    SUCCESS: 'Experiment started',
    FAILED: 'Experiment start failed',
  },
  PAUSED: {
    SUCCESS: 'Experiment paused',
    FAILED: 'Experiment pause failed',
  },
  ENDED: {
    SUCCESS: 'Experiment ended',
    FAILED: 'Experiment end failed',
  },
  DUPLICATE: {
    SUCCESS: 'Experiment duplicated',
    FAILED: 'Experiment duplicate failed',
  },
  QUERY: {
    SUCCESS: 'Experiment query success',
    FAILED: 'Experiment not found',
  },
  REMOVE_TEMPLATE: {
    SUCCESS: 'Template removed',
    FAILED: 'Failed to remove template from experiment',
  },
};
